import { render, staticRenderFns } from "./rightTop.vue?vue&type=template&id=5a4b4b8a&scoped=true"
import script from "./rightTop.vue?vue&type=script&lang=js"
export * from "./rightTop.vue?vue&type=script&lang=js"
import style0 from "./rightTop.vue?vue&type=style&index=0&id=5a4b4b8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4b4b8a",
  null
  
)

export default component.exports